/* ==========================================================================
   Benefit / Proof split — entrance animation (fade-up)
   Vanilla JS. Loaded once even across multiple section instances.
   Adds `is-visible` to each `--animate` section when it scrolls into view.
   Honors prefers-reduced-motion and the Shopify theme editor.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__benefitProofSplitInit) return;
  window.__benefitProofSplitInit = true;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) { el.classList.add('is-visible'); }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll('.benefit-proof-split--animate:not([data-bps-ready])');
    if (!els.length) return;

    // No observer support or reduced motion → show immediately, no animation.
    if (REDUCE || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.setAttribute('data-bps-ready', '');
        reveal(el);
      });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-bps-ready', '');
      io.observe(el);
    });
  }

  function boot() { init(document); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Theme editor: a section was (re)loaded — initialise any new instances.
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
